import VBtn from './VBtn'

VBtn.install = function install (Vue) {
  Vue.component(VBtn.name, VBtn)
}

export default VBtn



// WEBPACK FOOTER //
// ./src/components/VBtn/index.js